import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getRepositoryQueryKey, OrderItemClaimParameters, useRepositoryRegistry } from '@mews-commander/data-access';

type Params = Pick<OrderItemClaimParameters, 'orderItemClaims'>;

export const useClaimOrderItemsMutation = () => {
    const { orderItems } = useRepositoryRegistry();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (params: Params) => orderItems.updateClaimed(params),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: getRepositoryQueryKey('productChecklist') });
        },
    });
};
